import { useGetPortfolioInvestmentsByVolatilityQuery } from "../../../services/valuations";

const usePortfolioInvestmentsByVolatility = (masterAccountId) => {
    const { data, error, isError, isLoading, isFetching, isUninitialized, refetch } = useGetPortfolioInvestmentsByVolatilityQuery({ masterAccountId }/*, { refetchOnMountOrArgChange: true }*/);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        reload : refetch
    };

};

export default usePortfolioInvestmentsByVolatility;